import createAsyncActionType from '../../../utilities/createAsyncActionType';

export const UPDATE_WATCH_LIST_ENTRY_EU_TERRORISTS = createAsyncActionType('UPDATE_WATCH_LIST_ENTRY_EU_TERRORISTS');

export const CREATE_WATCH_LIST_ENTRY_EU_TERRORISTS = createAsyncActionType('CREATE_WATCH_LIST_ENTRY_EU_TERRORISTS');


// WEBPACK FOOTER //
// ./src/features/watch-list-entry-eu-terrorists/types/watchListEntryTypes.js